import { render, staticRenderFns } from "./RejectedReadsDropdown.vue?vue&type=template&id=4e506a71&scoped=true"
import script from "./RejectedReadsDropdown.vue?vue&type=script&lang=js"
export * from "./RejectedReadsDropdown.vue?vue&type=script&lang=js"
import style0 from "./RejectedReadsDropdown.vue?vue&type=style&index=0&id=4e506a71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e506a71",
  null
  
)

export default component.exports